<template>
    <div id="app">
      <h3 class="title has-text-centered">STATISTIK GERAKAN PANDAI</h3>
         <!-- <section class="hero is-info">
            <div class="hero-body">
            <p class="title has-text-centered">
                STATISTIK GERAKAN PANDAI
            </p>
            </div>
      </section> -->
      <section>
        <!-- <div class="container" style="margin-top: 5%;width:600px"> -->
            <!-- <h1 class="title has-text-centered">Reporting All</h1> -->
           
            <!-- <div class="columns">
              <div class="column">
                 <b-field
                  label="Bulan">
                  <b-select placeholder="Select a month" expanded  v-model="month" @input="getStatistik()">
                      <option v-for="item in bulan" :key="item.id" 
                      :value="item.id" >
                      {{item.name}}
                      </option>
                  </b-select>
              </b-field>
              </div>
              <div class="column">
                <b-field
                  label="Tahun">
                  <b-select placeholder="Select a year" expanded v-model="year" @input="getStatistik()">
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                  </b-select>
              </b-field>
              </div>

            </div> -->
             <!-- <div class="container" style="margin-top: 5%">
              <p class="subtitle is-5 has-text-centered">Jumlah Guru Belajar CT</p>
              <line-chart :chart-data="dataCollection"></line-chart>
            </div> -->

           
              
            <div class="container" style="margin-top: 5%">
              <p class="subtitle is-5 has-text-centered">Jumlah Event Pelatihan CT </p>
              <line-chart :chart-data="dataEvent"></line-chart>
            </div>

            <div class="container" style="margin-top: 5%">
              <p class="subtitle is-5 has-text-centered">Jumlah Peserta Guru Pelatihan CT </p>
              <line-chart :chart-data="dataPeserta"></line-chart>
            </div>

             <div class="container" style="margin-top: 5%">
              <p class="subtitle is-5 has-text-centered">Jumlah Peserta Siswa Belajar CT</p>
              <line-chart v-show="loaded" :chart-data="dataSiswa"></line-chart>
            </div>
             
        <!-- </div> -->

      </section>
       <section class="hero is-info">
            <div class="rows">
                <div class="row">
                    <div class="column">
                         <b-button  class="button is-info" 
                            tag="router-link"
                            to="/homepage"
                            icon-left="arrow-left-bold">Back to Home</b-button>
                    </div>
                </div>
            </div>
        </section>

    </div>    
</template>
<script>
import LineChart from '../chart/LineChart.vue'
export default {
  components:{
    LineChart,
  },
  data : () => ({
    // bulan : [
    //   {id: 1, name:'Januari'},
    //   {id: 2, name:'Febuari'},
    //   {id: 3, name:'Maret'},
    //   {id: 4, name:'April'},
    //   {id: 5, name:'Mei'},
    //   {id: 6, name:'Juni'},
    //   {id: 7, name:'Juli'},
    //   {id: 8, name:'Agustus'},
    //   {id: 9, name:'September'},
    //   {id: 10, name:'Oktober'},
    //   {id: 11, name:'November'},
    //   {id: 12, name:'Desember'},

    // ],
    dataCollection: null,
    label: null,
    apiData: null,
    loaded:false,

    dataSiswa: null,
    labelSiswa : null,
    apiDataSiswa :null,

    dataEvent: null,
    labelEvent : null,
    apiDataEvent :null,

    dataPeserta: null,
    labelPeserta : null,
    apiDataPeserta :null,
    // month:'',
    // year:''

  }),
  methods:{
    randomcolor()
    {
      var randomColor = Math.floor(Math.random()*16777215).toString(16);

      return "#" + randomColor;
    },
     async getGuru(){
      this.loaded=false
      // this.label = null
      // this.apiData = null
      var url =  this.$apiUrl + 'grafikall/jmlguru' 
      try {
        const response = await this.$http.get(url);
        
        let results = response.data

        let labelResult = results.value.map(a => a.label)
        let dataResult = results.value.map(a => a.data)

        let labelKumulatif = results.kumulatif.map(a => a.label)
        let dataKumulatif = results.kumulatif.map(a => a.data)

        let backgroundColor = []
        dataResult.forEach(element => {
          backgroundColor.push(this.randomcolor())
        });

        // console.log(labelResult)

        this.label = labelResult
        this.apiData = dataResult

        this.dataCollection = {
          labels: this.label,
          datasets: [
            {
              label: 'Guru',
              backgroundColor: 'transparent',
              borderColor: 'blue',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'blue',
              data: this.apiData
            },
             {
              label: 'Kumulatif',
              backgroundColor: 'transparent',
              borderColor: 'red',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'red',
              data: dataKumulatif
            },
          ]
        }
        this.loaded=true
      } catch (e) {
        console.log(e)
      }
    },

    async getEvent(){
      this.loaded=false
      // this.label = null
      // this.apiData = null
      var url =  this.$apiUrl + 'grafikall/event' 
      try {
        const response = await this.$http.get(url);
        
        let results = response.data

        let labelResult = results.value.map(a => a.label)
        let dataResult = results.value.map(a => a.data)

        let labelKumulatif = results.kumulatif.map(a => a.label)
        let dataKumulatif = results.kumulatif.map(a => a.data)

        let backgroundColor = []
        dataResult.forEach(element => {
          backgroundColor.push(this.randomcolor())
        });

        // console.log(backgroundColor)

        this.labelEvent = labelResult
        this.apiDataEvent = dataResult

        this.dataEvent = {
          labels: this.labelEvent,
          datasets: [
            {
              label: 'Event',
              backgroundColor: 'transparent',
              borderColor: 'blue',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'blue',
              data: this.apiDataEvent
            },
             {
              label: 'Kumulatif',
              backgroundColor: 'transparent',
              borderColor: 'red',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'red',
              data: dataKumulatif
            },
          ]
        }
        this.loaded=true
      } catch (e) {
        console.log(e)
      }
    },

    async getSiswa(){
      this.loaded=false
      // this.label = null
      // this.apiData = null
      var url =  this.$apiUrl + 'grafikall/jmlsiswa' 
      try {
        const response = await this.$http.get(url);
        
        let results = response.data

        let labelResult = results.value.map(a => a.label)
        let dataResult = results.value.map(a => a.data)

        let labelKumulatif = results.kumulatif.map(a => a.label)
        let dataKumulatif = results.kumulatif.map(a => a.data)


        let backgroundColor = []
        dataResult.forEach(element => {
          backgroundColor.push(this.randomcolor())
        });

        console.log(backgroundColor)

        this.labelSiswa = labelResult
        this.apiDataSiswa = dataResult

        this.dataSiswa = {
          labels: this.labelSiswa,
         datasets: [
            {
              label: 'Siswa',
              backgroundColor: 'transparent',
              borderColor: 'blue',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'blue',
              data: this.apiDataSiswa
            },
             {
              label: 'Kumulatif',
              backgroundColor: 'transparent',
              borderColor: 'red',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'red',
              data: dataKumulatif
            },
          ]
        }
        this.loaded=true
      } catch (e) {
        console.log(e)
      }
    },

    async getPeserta(){
      this.loaded=false
      // this.label = null
      // this.apiData = null
      var url =  this.$apiUrl + 'grafikall/jmlguru' 
      try {
        const response = await this.$http.get(url);
        
        let results = response.data

        let labelResult = results.value.map(a => a.label)
        let dataResult = results.value.map(a => a.data)

        let labelKumulatif = results.kumulatif.map(a => a.label)
        let dataKumulatif = results.kumulatif.map(a => a.data)

        let backgroundColor = []
        dataResult.forEach(element => {
          backgroundColor.push(this.randomcolor())
        });

        // console.log(backgroundColor)

        this.labelPeserta = labelResult
        this.apiDataPeserta = dataResult

        this.dataPeserta = {
          labels: this.labelPeserta,
          datasets: [
            {
              label: 'Jumlah Peserta',
              backgroundColor: 'transparent',
              borderColor: 'blue',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'blue',
              data: this.apiDataPeserta
            },
             {
              label: 'Kumulatif',
              backgroundColor: 'transparent',
              borderColor: 'red',
              pointBackgroundColor: 'white',
              borderWidth: 2,
              pointBorderColor: 'red',
              data: dataKumulatif
            },
          ]
        }
        this.loaded=true
      } catch (e) {
        console.log(e)
      }
    },

  },
  
  mounted(){
    // let today = new Date()
    // this.month = today.getMonth() + 1
    // this.year = today.getFullYear()
    this.getSiswa()
    // this.getGuru()
    this.getEvent()
    this.getPeserta()
  }
}
</script>
